// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.pi.pi-spin[data-v-60a2fe69] {\n  opacity: 0.65;\n  font-size: 2.1rem !important;\n}\ndiv[data-v-60a2fe69] {\n  min-height: 40vh;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
